import App from './../app.jsx';

import Home from './../pages/home/home.js';
import Error from './../pages/error/error.js';
import MyLogin from './../pages/auth/login.js';
import Logout from './../pages/auth/logout.js';
import PrivateRoute from '../components/auth/private-route.js';
import ReviewList from './../pages/review/ReviewList.jsx';
import MallRankingList from '../pages/ranking/MallRankingList.jsx';
import TotalRankingList from '../pages/ranking/TotalRankingList.jsx';
import BarcodePrinter from './../pages/barcode/BarcodePrinter.jsx';
import TemplateList from './../pages/barcode/TemplateList.jsx';
import RakutenEventPageList from './../pages/rakuten-event/RakutenEventPageList.jsx';
import RakutenEventTemplateList from './../pages/rakuten-event/RakutenEventTemplateList.jsx';
import RakutenEventWorkspace from './../pages/rakuten-event/RakutenEventWorkspace.jsx';
import RakutenUnderCartItemList from './../pages/rakuten-event/RakutenUnderCartItemList.jsx';
import RakutenEventProductEdit from './../pages/rakuten-event/RakutenEventProductEdit.jsx';
import RakutenItemTagManager from './../pages/rakuten-event/RakutenItemTagManager.jsx';
import SettingsPage from './../pages/setting/SettingsPage.jsx';
import Suppliers from './../pages/purchase/Suppliers.jsx';
import ProductList from './../pages/purchase/ProductList.jsx';
import ProductDetail from './../pages/purchase/ProductDetail.jsx'
import PurchaseOrders from './../pages/purchase/PurchaseOrders.jsx';
import PurchaseOrderCreate from '../pages/purchase/PurchaseOrderCreate.jsx';
import PurchaseOrderDetail from '../pages/purchase/PurchaseOrderDetail.jsx';
import CategoryMaster from '../pages/master/CategoryMaster.jsx';
import CategoryMapping from '../pages/master/CategoryMapping.jsx';
import VariantOptionMaster from '../pages/master/VariantOptionMaster.jsx';


const AppRoute = [
  {
    path: '/',
    element: <App />,
    children: [
      {
        path: '*', element: <Error />
      }, {
        path: 'login',
        element: <MyLogin />
      },
      {
        path: 'logout',
        element: <Logout />
      },
      {
        // この中はログインしたときのみ表示
        element: <PrivateRoute />,
        children: [
          {
            path: '', element: <Home />
          },
          {
            path: 'ranking/total',
            element: <TotalRankingList />
          },
          {
            path: 'review/:mall',
            element: <ReviewList />
          },
          {
            path: 'ranking/:mall',
            element: <MallRankingList />
          },
          {
            path: 'barcode',
            element: <BarcodePrinter />
          },
          {
            path: 'barcode/template',
            element: <TemplateList />
          },
          {
            path: 'rakuten-event/pages',
            element: <RakutenEventPageList />
          },
          {
            path: 'rakuten-event/template',
            element: <RakutenEventTemplateList />
          },
          {
            path: 'rakuten-event/workspace',
            element: <RakutenEventWorkspace />
          },
          {
            path: 'rakuten-event/products', // カテゴリ別登録アイテム一覧
            element: <RakutenUnderCartItemList />
          },
          {
            path: 'rakuten-event/product/edit', // 商品個別登録・編集
            element: <RakutenEventProductEdit />
          },
          {
            path: 'rakuten-event/tags', // 楽天ジャンル・タグID管理（カラーパレット確認）
            element: <RakutenItemTagManager />
          },
          {
            path: 'settings',
            element: <SettingsPage />
          },
          {
            path: 'purchase/suppliers',
            element: <Suppliers />
          },
          {
            path: 'purchase/purchase-orders',
            element: <PurchaseOrders />
          },
          {
            path: 'purchase/products',
            element: <ProductList />
          },
          {
            path: 'purchase/products/edit/:uuid',
            element: <ProductDetail />
          },
          {
            path: 'purchase/purchase-orders/create',
            element: <PurchaseOrderCreate />
          },
          {
            path: 'purchase/purchase-orders/:uuid',
            element: <PurchaseOrderDetail />
          },
          {
            path: 'master/categories',
            element: <CategoryMaster />
          },
          {
            path: 'master/category-mapping',
            element: <CategoryMapping />
          },
          {
            path: 'master/variant-options',
            element: <VariantOptionMaster />
          },
        ]
      },



    ]
  }
];


export default AppRoute;